import { Link } from 'react-router-dom';
import { useLibrary } from './LibraryContext';
import { CATEGORIES } from '../lib/library';

export const SeriesNavigation=({catalog,selected,choose,compact=false})=>{
 const {path}=useLibrary();
 return <nav className={`journal-series-nav ${compact?'compact':''}`} aria-label="Archive libraries">
  <button data-testid="category-all" className={!selected?'active':''} onClick={()=>choose('')}><span>All readings</span><small>{catalog?.total?.toLocaleString()??'—'}</small></button>
  {(compact?CATEGORIES.slice(0,3):CATEGORIES).map(c=>{const count=catalog?.libraries?.find(l=>l.id===c.id)?.public_count;return <button data-testid={`category-${c.id}`} key={c.id} className={selected===c.id?'active':''} onClick={()=>choose(c.id)}><span>{c.name}</span><small>{count?.toLocaleString()??'—'}</small></button>;})}
  {compact&&<Link data-testid="series-all-intersections" className="journal-intersections-link" to={path('/explore?view=intersections')}>Intersections ↗</Link>}
 </nav>;
};